<template>
  <ModalDialog
    ref="dialog"
    title="Convert Order Items"
    submitTitle="Convert"
    icon="fa-exchange"
    :scrollable="true"
    :submitDisabled="!hasItemsSelected"
    @closed="onClosed"
    @submitted="onSubmitted">

    <NotificationBar type="info">
      <NotificationBarTitle>Convert Order Items</NotificationBarTitle>
      <ul>
        <li>Select order items that were entered as line items to be converted into rectangles in the order editor</li>
        <li>Any non-edgework services (eg, cutouts) will not be converted</li>
        <li>Please verify the shapes and services after conversion</li>
        <li>Once converted, editor order items cannot be converted back to regular line items</li>
      </ul>
    </NotificationBar>

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="6">
      <ContentTitle>Order Item List</ContentTitle>
      <Scroller :maxHeight="350">
        <StaticDataTable class="static-table-list">
          <template v-slot:header>
            <tr>
              <th>Order Item</th>
              <th>Convert</th>
            </tr>
          </template>
          <template v-slot:body>
            <tr v-for="(orderItem, index) of convertList" :key="index">
              <td>{{orderItem.name}}</td>
              <td>
                <FormCheckbox v-model="orderItem.convert" />
              </td>
            </tr>
          </template>
          <template v-slot:empty v-if="convertList.length == 0">No line items found</template>
        </StaticDataTable>
      </Scroller>
    </FormGroup>

  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import Utils from '@/utils/utils'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { InventoryStockTypes } from '@/store/types'

export default {
  name: 'ConvertOrderItemDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    editor: Object,
    order: Object
  },
  data() {
    return {
      dialogForm: {},
      convertList: []
      
    }
  },
  mounted() {
    this.convertList = this.order.orderItems
      .filter(orderItem => {
        if(orderItem.isEditorGeneratedItem)
          return false

        // Root items only
        if(orderItem.parentOrderItemId != null)
          return false

        // Glass only
        if(orderItem.stockType != InventoryStockTypes.glass)
          return false

        // Ignore stock only price groups
        if(orderItem.stockPriceGroup && orderItem.stockPriceGroup.isStockLinked)
          return false

        // Ignore cancelled
        if(orderItem.isCancelled)
          return false

        return true
      })
      .map(orderItem => {
        return {
          id: orderItem.id,
          name: `${orderItem.quantity}x ${orderItem.description} ${orderItem.generatedDescription ? ('- ' + orderItem.generatedDescription + ' - ') : ''}${orderItem.glassHeight}x${orderItem.glassWidth}`,
          convert: false
        }
      })
  },
  computed: {
    hasItemsSelected() {
      return this.convertList.some(orderItem => orderItem.convert)
    }
  },
  methods: {
    show(options = {}) {
      // Reset form
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.dialogForm = this.clearFormResponse()

      this.modalClosed(this.convertList.filter(orderItem => orderItem.convert))
      this.hide()
    }
  }
}
</script>